import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, retry, throwError, map, tap } from 'rxjs';
import { RequestOptions } from '../modal/RequestOptions';
import { environment } from '../../environments/environments';
import { servico } from '../modal/regional/servico';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
    providedIn: 'root',
})
export class AuthService {


    private refreshTimer: any = null;

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        withCredentials: false
    };
    constructor(private http: HttpClient, private oauthService: OAuthService,) { }
    private apiUrl = environment.API_URL;
    private map = "ss.usuario";
    headers = new HttpHeaders().set('Content-Type', 'application/json');

    isTokenValid(): boolean {
        return this.oauthService.hasValidAccessToken();
    }

    getNewToken(): string {
        return this.oauthService.getAccessToken();
    }

    findConfigCiberArk(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}auth/cyberark/findConfigCiberArk`);
    }

    setStatusCiberArk(status: boolean): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}auth/cyberark/setStatusCiberArk?status=` + status);
    }

    getRoles(cpf: string): Observable<any> {
        return this.http.post(this.apiUrl + this.map + '/findByCPF', cpf, this.httpOptions)
            .pipe(retry(1), catchError(this.handleError))
    }

    getNomeUsuario(cpf: string): Observable<any> {
        return this.http.post(this.apiUrl + this.map + '/findNomeUsuario', cpf, this.httpOptions)
            .pipe(retry(1))
    }

    public handleError(error: HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Cliente-side error
            errorMessage = `Erro do cliente: ${error.error.message}`;
        } else if (error.error && error.error.message) {
            // Verificação adicional para erros no lado do servidor
            errorMessage = `Erro do servidor: ${error.error.message}`;
        } else {
            // Resposta de erro do servidor sem um corpo de erro específico
            errorMessage = `Código do erro: ${error.status}, mensagem: ${error.statusText}`;
        }
        console.error(errorMessage);
        return throwError(() => new Error(errorMessage));
    }

    role(): string {
        var valor: any = localStorage.getItem('salaSituacao');
        var local = JSON.parse(valor);
        let role = local.perfil;
        return role;
    }

    async roleWithTempAsync(): Promise<string> {
        var valor: any = await this.readLocalStorageWithExponentialBackoff('salaSituacao');
        var local = JSON.parse(valor);
        let role = local.perfil;
        return role;
    }


    roleWithTemp(): string {
        this.readLocalStorageWithExponentialBackoff('salaSituacao', 10)
            .then(valor => {
                if (valor === null) {
                    console.warn('Não encontrou valor após todas as tentativas.');
                } else {
                    console.log(valor);
                    var local = JSON.parse(valor);
                    let role = local.perfil;
                    return role;
                }
            })
            .catch(err => console.error('Erro:', err));
        return "";
    }


    async readLocalStorageWithExponentialBackoff(
        key: string,
        maxRetries = 5,
        baseDelayMs = 1000
    ): Promise<string | null> {
        let attempt = 0;
        const isEmpty = (v: string | null) => v === null || v === '' || v === 'null' || v === 'undefined';

        while (attempt <= maxRetries) {
            const value = localStorage.getItem(key);
            if (!isEmpty(value)) return value;

            if (attempt === maxRetries) return null;

            const delayMs = baseDelayMs * Math.pow(2, attempt); // 300, 600, 1200, ...
            await new Promise(res => setTimeout(res, 5000));
            attempt++;
        }
        return null;
    }

    getVersionamento(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}${this.map}/getVersionamento`);
    }

    atualizarListaPostosERegiaoUsuario() {
        var salaSituacao;
        let claims = this.oauthService.getIdentityClaims();
        if (claims) {
            this.getRoles(claims['preferred_username']).pipe().subscribe((response) => {
                salaSituacao = response['meusDados']['roles']['salaSituacao'];
                localStorage.setItem('salaSituacao', JSON.stringify(salaSituacao));
            });
        }
    }


    logoutCyberArk(): Observable<string> {

        // chamada ao backend WebFlux
        return this.http.post<{ redirectUrl: string }>(
            `${this.apiUrl}auth/cyberark/logout`,
            {}
        ).pipe(
            map(resp => resp.redirectUrl ?? '')
        );
    }

    startAutoRefresh() {

        const provider = localStorage.getItem('auth_provider');
        if (provider !== 'CYBERARK') return;

        const token = localStorage.getItem('token');
        if (!token) return;

        this.scheduleRefresh();
    }

    startRefreshTimerIfNeeded(): string {
        const nowMs = Date.now();
        if (this.refreshTimer == null) {
            var targetMillisString = localStorage.getItem("expiresToken");
            //alert("targetMillisString= "+ targetMillisString);
            if (targetMillisString != null) {
                const targetMs = Number(targetMillisString);


                const buffer = 60_000; // renovar 60s antes

                const delay = targetMs - nowMs - buffer;
                //alert("scheduleRefresh delay="+delay+" targetMs="+targetMs);
                //alert("time= " + delay);
                if (delay <= 0) {
                    const nowMs = Date.now();
                    var targetMillisString = localStorage.getItem("expiresToken");
                    //alert("targetMillisString= "+ targetMillisString);
                    if (targetMillisString != null) {
                        const targetMs = Number(targetMillisString);


                        const buffer = 60_000; // renovar 60s antes

                        const delay = targetMs - nowMs - buffer;
                        //alert("scheduleRefresh delay="+delay+" targetMs="+targetMs);
                        //alert("time= " + delay);
                        if (delay <= 0) {
                            const token = localStorage.getItem('token') ?? '';
                            localStorage.removeItem('expiresToken');
                            this.http.post<{ accessToken: string, expires: string; }>(
                                `${this.apiUrl}auth/cyberark/renew`,
                                {},
                                {
                                    headers: { Authorization: `Bearer ${token}` }
                                }
                            ).pipe(
                                tap(resp => {
                                    localStorage.setItem('token', resp.accessToken);
                                    localStorage.setItem('expiresToken', resp.expires);
                                    //alert("novo token="+ resp.accessToken);
                                    // reagendar a próxima
                                    this.scheduleRefresh();
                                    return resp.accessToken;
                                })
                            );
                        }

                        clearTimeout(this.refreshTimer);

                        this.refreshTimer = setTimeout(() => {
                            this.doRefresh().subscribe();
                        }, delay);
                        const token = localStorage.getItem('token') ?? '';
                        return token;
                    }
                    else {
                        clearTimeout(this.refreshTimer);
                        const token = localStorage.getItem('token') ?? '';
                        return token;
                    }
                }

                clearTimeout(this.refreshTimer);

                this.refreshTimer = setTimeout(() => {
                    this.doRefresh().subscribe();
                }, delay);
            }
            else {
                clearTimeout(this.refreshTimer);
                const token = localStorage.getItem('token') ?? '';
                return token;
            }
        }
        else {
            const token = localStorage.getItem('token') ?? '';
            return token;
        }
        const token = localStorage.getItem('token') ?? '';
        return token;
    }

    scheduleRefresh() {
        const nowMs = Date.now();
        var targetMillisString = localStorage.getItem("expiresToken");
        //alert("targetMillisString= "+ targetMillisString);
        if (targetMillisString != null) {
            const targetMs = Number(targetMillisString);


            const buffer = 60_000; // renovar 60s antes

            const delay = targetMs - nowMs - buffer;
            //alert("scheduleRefresh delay="+delay+" targetMs="+targetMs);
            //alert("time= " + delay);
            if (delay <= 0) {
                this.doRefresh().subscribe();
                return;
            }

            clearTimeout(this.refreshTimer);

            this.refreshTimer = setTimeout(() => {
                this.doRefresh().subscribe();
            }, delay);
        }
        else {
            clearTimeout(this.refreshTimer);
        }
    }

    doRefresh(): Observable<string> {
        //alert("doRefresh");
        const token = localStorage.getItem('token') ?? '';
        localStorage.removeItem('expiresToken');
        return this.http.post<{ accessToken: string, expires: string; }>(
            `${this.apiUrl}auth/cyberark/renew`,
            {},
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        ).pipe(
            tap(resp => {
                localStorage.setItem('token', resp.accessToken);
                localStorage.setItem('expiresToken', resp.expires);
                //alert("novo token="+ resp.accessToken);
                // reagendar a próxima
                this.scheduleRefresh();
            }),
            map(resp => resp.accessToken)
        );
    }

    exchangeCyberArkCode(code: string): Observable<{
        jwt: string, usuario: string, expires: string;
    }> {
        //alert(window.location.origin);
        return this.http.post<{ jwt: string, usuario: string, expires: string }>(
            `${this.apiUrl}auth/cyberark/exchange`,
            {
                code,
                redirectUri: window.location.origin + "/"
            }
        );
    }
}
function jwt_decode<T>(token: string): { exp: any; } {
    throw new Error('Function not implemented.');
}

